<template>
  <p class="wrap-content">
    <a v-if="externalUrl" :href="externalUrl" target="_blank" external class="external link">
      <span>{{ content }}</span>
      <a class="more external link">more&#32;<img src="/static/icons/link.svg"/></a>
    </a>
    <span v-else :class="className" @click="()=> onToPostDetail()">{{ content }}</span>
    <span class="more" v-if="isShow && !externalUrl && !isDetail" @click="()=> onToPostDetail()">more</span>
  </p>
</template>
<script>
export default {
  props: {
    onToPostDetail: {
      required: false,
      type: Function,
      default() {
        return () => this.onHandleDefault();
      }
    },
    isShow: {
      required: false,
      type: Boolean,
      default: true
    },
    isDetail: {
      required: false,
      type: Boolean,
      default: false
    },
    externalUrl: {
      required: false,
      type: String
    },
    content: {
      required: false,
      type: String
    },
    className: {
      required: false,
      type: String
    }
  },
  methods: {
    onHandleDefault() {
      return null;
    }
  }
};
</script>

